import React from "react";
import { Box, Typography } from "@mui/material";

const Footer = ({ sx }) => {
  return (
    <Box
      sx={{
        background: "linear-gradient(180deg, #0b1e3d 0%, #0d2b5e 100%)",
        borderTop: "1px solid rgba(255,255,255,0.07)",
        py: 1,
        px: 2,
        textAlign: "center",
        flexShrink: 0,
        ...sx,
      }}
    >
      <Typography
        variant="caption"
        sx={{ color: "rgba(255,255,255,0.4)", letterSpacing: "0.3px" }}
      >
        © 2025 MONIT pvt ltd. All Rights Reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
